module.exports = __webpack_public_path__ + "static/media/Neurips2020.e836e643.ipynb";